import * as ko from "knockout";
import * as mapping from "knockout.mapping";

export class Newspaper {
    Id: any;
    Name: any;
    TopicId: any;

    constructor(json?: any) {
        this.Id = ko.observable<number>();
        this.Name = ko.observable<string>();
        this.TopicId = ko.observable<number>();

        if (json) {
            mapping.fromJS(json, {}, this);
        }
    }
}